<template>
    <Badge variant="accent" class="size-8">
        <Icon class="text-xl" :name="iconName" />
    </Badge>
</template>

<script setup lang="ts">
const props = defineProps<{ modifier: Modifier }>();

const iconName = computed(() => (props.modifier === Modifier.GreaterThan ? "caret-up" : "caret-down"));
</script>
